/* VÖRR 07-10 - botão FEEDBACK + pop-up (arquivo isolado). Só lê e escreve dentro do próprio pop-up. */
(function () {
  'use strict';

  var tab = document.getElementById('vorrFbTab');
  var root = document.getElementById('vorrFb');
  var cfgEl = document.getElementById('vorr-fb-config');
  if (!tab || !root || !cfgEl || root.dataset.ready) return;
  root.dataset.ready = '1';

  // Quem já respondeu não vê mais o botão neste navegador (não fica repetitivo)
  var SENT_KEY = 'vorr_fb_enviado';
  function alreadySent() { try { return !!window.localStorage.getItem(SENT_KEY); } catch (e) { return false; } }
  function markSent() { try { window.localStorage.setItem(SENT_KEY, new Date().toISOString()); } catch (e) {} }
  if (alreadySent()) { tab.style.display = 'none'; return; }

  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent) || {}; } catch (e) {}

  var html = document.documentElement;
  var panel = root.querySelector('.vorr-fb__panel');
  var form = root.querySelector('form');
  var stepForm = root.querySelector('[data-fb-step="form"]');
  var stepDone = root.querySelector('[data-fb-step="done"]');
  var submitBtn = root.querySelector('[data-fb-submit]');
  var stars = Array.prototype.slice.call(root.querySelectorAll('.vorr-fb__star'));
  var radios = Array.prototype.slice.call(root.querySelectorAll('.vorr-fb__radio'));
  var emailInput = form.elements.email;
  var MIN_MS = 1600;
  var state = { open: false, sending: false, sent: false, openedAt: 0, lastFocus: null, hover: 0, closeTimer: null };

  // 07-10 (v2): iPhone dá zoom ao tocar em campo com letra menor que 16px. Em vez de aumentar a letra dos campos
  // (ficavam maiores que o resto do pop-up), o zoom automático fica desligado só enquanto o pop-up está aberto.
  // O iPhone continua permitindo o zoom de pinça do cliente. Ao fechar, o viewport volta exatamente ao original.
  var IS_IOS = !!(window.CSS && CSS.supports && CSS.supports('-webkit-touch-callout', 'none'));
  var viewport = document.querySelector('meta[name="viewport"]');
  var viewportOriginal = viewport ? viewport.getAttribute('content') : null;
  function iosNoZoom(on) {
    if (!IS_IOS || !viewport || viewportOriginal === null || /maximum-scale/i.test(viewportOriginal)) return;
    viewport.setAttribute('content', on ? viewportOriginal + ', maximum-scale=1' : viewportOriginal);
  }

  // Mesma escrita do "Ajuda?": copia fonte, tamanho e espaçamento do botão Ajuda (negrito fica fixo no CSS)
  function matchAjuda() {
    var ajuda = document.getElementById('ajudaBtn');
    if (!ajuda) return;
    var cs = window.getComputedStyle(ajuda);
    ['fontFamily', 'fontSize', 'letterSpacing', 'textTransform', 'fontStyle'].forEach(function (p) {
      if (cs[p]) tab.style[p] = cs[p];
    });
  }
  matchAjuda();

  // Mesmo comportamento do "Ajuda?": aparece esmaecido suavemente após 1 segundo
  setTimeout(function () { if (state.sent) return; matchAjuda(); tab.classList.add('is-visible'); warmLogo(); }, 1000);

  // Logo do pop-up: carrega em segundo plano assim que o botão aparece, para já estar pronta ao abrir
  function warmLogo() {
    var img = root.querySelector('.vorr-fb__logo img');
    if (img && img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
  }
  tab.addEventListener('pointerenter', warmLogo);
  tab.addEventListener('touchstart', warmLogo, { passive: true });
  tab.addEventListener('focus', warmLogo);

  function err(name, msg) {
    var el = root.querySelector('[data-fb-error="' + name + '"]');
    if (!el) return;
    if (msg) { if (name === 'form') el.textContent = msg; el.hidden = false; }
    else el.hidden = true;
  }

  function currentNota() {
    var c = form.querySelector('input[name="nota"]:checked');
    return c ? parseInt(c.value, 10) : 0;
  }

  function paintStars() {
    var n = state.hover || currentNota();
    stars.forEach(function (s, i) { s.classList.toggle('is-on', i < n); });
  }

  function paintRadios() {
    radios.forEach(function (r) { r.classList.toggle('is-checked', r.querySelector('input').checked); });
  }

  function focusables() {
    return Array.prototype.slice.call(panel.querySelectorAll('a[href],button:not([disabled]),select,textarea,input:not([type="hidden"]):not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
  }

  function resetForm() {
    form.reset();
    if (emailInput && emailInput.defaultValue) emailInput.value = emailInput.defaultValue;
    state.hover = 0;
    paintStars(); paintRadios();
    ['motivo', 'nota', 'email', 'form'].forEach(function (n) { err(n, null); });
    if (emailInput) emailInput.removeAttribute('aria-invalid');
    form.elements.motivo.removeAttribute('aria-invalid');
    stepForm.hidden = false;
    stepDone.hidden = true;
  }

  function open() {
    if (state.open) return;
    clearTimeout(state.closeTimer);
    state.open = true;
    state.lastFocus = document.activeElement;
    state.openedAt = Date.now();
    iosNoZoom(true);
    // Compensa a barra de rolagem para a página não "andar" para o lado ao travar o scroll
    var sw = window.innerWidth - html.clientWidth;
    if (sw > 0) document.body.style.paddingRight = sw + 'px';
    html.classList.add('vorr-fb-lock');
    root.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      panel.focus({ preventScroll: true });
    });
  }

  function close() {
    if (!state.open) return;
    state.open = false;
    iosNoZoom(false);
    root.classList.remove('is-open');
    html.classList.remove('vorr-fb-lock');
    document.body.style.paddingRight = '';
    state.closeTimer = setTimeout(function () {
      root.hidden = true;
      if (!stepDone.hidden) resetForm();
    }, 200);
    if (state.sent) {
      // Respondeu: o botão sai suavemente e não volta mais
      tab.classList.remove('is-visible');
      setTimeout(function () { tab.style.display = 'none'; }, 500);
      return;
    }
    if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus({ preventScroll: true });
  }

  tab.addEventListener('click', function () { warmLogo(); open(); });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-fb-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (!state.open) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Estrelas: preenchimento ao passar o mouse e ao selecionar
  stars.forEach(function (s, i) {
    s.addEventListener('mouseenter', function () { state.hover = i + 1; paintStars(); });
    s.addEventListener('mouseleave', function () { state.hover = 0; paintStars(); });
  });
  form.addEventListener('change', function (e) {
    if (e.target.name === 'motivo' && e.target.value) { e.target.removeAttribute('aria-invalid'); err('motivo', null); }
    if (e.target.name === 'nota') { err('nota', null); paintStars(); }
    if (e.target.name === 'concluiu') paintRadios();
  });
  if (emailInput) emailInput.addEventListener('input', function () {
    emailInput.removeAttribute('aria-invalid'); err('email', null);
  });

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (state.sending) return;
    err('form', null);

    var nota = currentNota();
    var email = (emailInput.value || '').trim().toLowerCase();
    var ok = true;
    if (!form.elements.motivo.value) { form.elements.motivo.setAttribute('aria-invalid', 'true'); err('motivo', true); ok = false; }
    if (!nota) { err('nota', true); ok = false; }
    if (!validEmail(email)) { emailInput.setAttribute('aria-invalid', 'true'); err('email', true); ok = false; }
    if (!ok) {
      var firstErr = root.querySelector('.vorr-fb__error:not([hidden])');
      if (firstErr) firstErr.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }

    var concluiu = form.querySelector('input[name="concluiu"]:checked');
    var payload = {
      email: email,
      nota: nota,
      motivo: form.elements.motivo.value || '',
      concluiu: concluiu ? concluiu.value : '',
      comentario: (form.elements.comentario.value || '').trim().slice(0, 1000),
      pagina: (location.pathname || '/').slice(0, 300),
      dispositivo: window.matchMedia('(max-width: 1023px)').matches ? 'Mobile' : 'Desktop',
      fb_ref_x: form.elements.fb_ref_x.value || '',
      elapsed: 0
    };

    state.sending = true;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Enviando...';

    var elapsed = Date.now() - state.openedAt;
    wait(Math.max(0, MIN_MS - elapsed))
      .then(function () {
        payload.elapsed = Date.now() - state.openedAt;
        return fetch(cfg.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(payload)
        });
      })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok || !data.ok) throw new Error(data.error || 'http_' + res.status);
        });
      })
      .then(function () {
        state.sent = true;
        markSent();
        stepForm.hidden = true;
        stepDone.hidden = false;
        panel.scrollTop = 0;
        var btn = stepDone.querySelector('button');
        if (btn) btn.focus({ preventScroll: true });
      })
      .catch(function () {
        err('form', 'Não foi possível enviar agora. Tente de novo em instantes.');
      })
      .then(function () {
        state.sending = false;
        submitBtn.disabled = false;
        submitBtn.textContent = 'Enviar';
      });
  });
})();
